module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.54b68217.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-BoldItalic.woff2
// module id = 682
// module chunks = 21